export default "__VITE_ASSET__DXG4yU5F__"